<div class="d-flex flex-column w-100 card" [style.backgroundColor]="scheduleEntry.shiftColor">
	<div class="display-12">{{ scheduleEntry.job.name }}</div>
	<div class="display-14">
		<div class="ms-1">{{ app.moment(scheduleEntry.startDateTime).format('LT') }} -</div>
		<div class="ms-1">{{ app.moment(scheduleEntry.endDateTime).format('LT') }}</div>
	</div>
</div>
